import { typesenseClient } from '@src/pages/question-bank';
import { SearchParams } from '@src/types/typesense';
import type { Hit } from 'instantsearch.js';

type FilterValue =
  | string
  | number
  | boolean
  | string[]
  | { operator: '>' | '>=' | '<' | '<=' | '=' | '!='; value: string | number };

type Filters = Record<string, FilterValue>;

export function buildFilterBy(filters: Filters): string {
  const parts: string[] = [];

  for (const [field, value] of Object.entries(filters)) {
    if (Array.isArray(value)) {
      parts.push(`${field}:[${value.join(',')}]`);
    } else if (typeof value === 'object' && 'operator' in value) {
      parts.push(`${field}:${value.operator}${value.value}`);
    } else if (typeof value === 'boolean') {
      parts.push(`${field}:${value}`);
    } else {
      parts.push(`${field}:${value}`);
    }
  }

  return parts.join(' && ');
}

export async function fetchSearchPage(params: SearchParams) {
  const p = {
    q: params.query,
    per_page: params.hitsPerPage,
    page: params.page + 1,
    filter_by: params.filter_by,
    sort_by: params.sortBy,
    query_by:
      'slug,resource_type,qualification,series,area,paper,difficulty,subtopic,division,keyword,question_image_text',
  };

  const res = await typesenseClient.collections('questions').documents().search(p, {});

  const hits = res.hits.map((hit) => hit.document) as Hit[];

  return {
    hits,
    page: res.page,
    nbPages: res.found ? Math.ceil(res.found / 12) : 0,
  };
}

export const extractFacetValues = (facetFilters: unknown, attribute: string): string[] => {
  if (!Array.isArray(facetFilters)) return [];

  const prefix = `${attribute}:`;
  return facetFilters.flatMap((group) =>
    Array.isArray(group)
      ? group
          .filter(
            (filter): filter is string => typeof filter === 'string' && filter.startsWith(prefix),
          )
          .map((filter) => filter.slice(prefix.length))
      : [],
  );
};

export const calculateIntersectionScore = (
  itemValues: string[] = [],
  selectedValues: string[],
): number => {
  return selectedValues.filter((value) => itemValues.includes(value)).length;
};
